const routes = [
  {
    path: '/support',
    meta: { isPublic: true, needMe: false, hideMenus: true },
    component: () => import('profiles/eurobits/views/Support.vue')
  },
  {
    path: '/supportAutoLogin',
    name: 'supportAutoLogin',
    meta: { needMe: false, hideMenus: true },
    component: () => import('profiles/eurobits/views/SupportAutoLogin.vue')
  }
]

export default routes
